// Parallax scrolling and animation effects for homepage
// Inspired by Bonnie Christine's smooth, elegant interactions

document.addEventListener('DOMContentLoaded', () => {
  // Parallax effect for hero image
  const parallaxImage = document.querySelector('[data-parallax-image]');
  const parallaxElements = document.querySelectorAll('[data-parallax-element]');
  
  if (parallaxImage || parallaxElements.length > 0) {
    let ticking = false;
    
    const updateParallax = () => {
      const scrolled = window.pageYOffset;
      
      // Hero image parallax (slower scroll)
      if (parallaxImage) {
        const speed = 0.5;
        parallaxImage.style.transform = `translateY(${scrolled * speed}px)`;
      }
      
      // Decorative elements parallax
      parallaxElements.forEach(element => {
        const speed = parseFloat(element.dataset.parallaxElement) || 0.3;
        element.style.transform = `translateY(${scrolled * speed}px)`;
      });
      
      ticking = false;
    };
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    });
  }
  
  // Scroll reveal animations for sections
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Trigger animations for children
        const animatedChildren = entry.target.querySelectorAll('.animate-fade-in-up');
        animatedChildren.forEach((child, index) => {
          setTimeout(() => {
            child.classList.add('is-visible');
          }, index * 100);
        });
      }
    });
  }, observerOptions);
  
  // Observe sections with scroll reveal
  const revealSections = document.querySelectorAll('[data-scroll-reveal]');
  revealSections.forEach(section => observer.observe(section));
  
  // Smooth hover effects for collection cards
  const collectionCards = document.querySelectorAll('[data-collection-card]');
  collectionCards.forEach(card => {
    card.addEventListener('mouseenter', (e) => {
      const img = card.querySelector('img');
      if (img) {
        img.style.transform = 'scale(1.1)';
      }
    });
    
    card.addEventListener('mouseleave', (e) => {
      const img = card.querySelector('img');
      if (img) {
        img.style.transform = 'scale(1)';
      }
    });
  });
  
  // Add smooth scroll behavior
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && document.querySelector(href)) {
        e.preventDefault();
        document.querySelector(href).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});
